<template>
  <BottomList :QueryData="QueryData" :detailData="detailData" />
</template>

<script>
import BottomList from './BottomList.vue'

export default {
  props: ['detailRuleObj', 'detailData'],
  components: {
    BottomList
  },
  data () {
    return {
      QueryData: []
    }
  },
  activated () {
    this.QueryData = [...this.detailRuleObj]
  }
}
</script>

<style></style>
